(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Invalid",
            {
                url: "/Invalid?param={parameter}",
                component: "invalid",
                resolve: {
                    password: ["$stateParams", function ($stateParams) {
                        console.log($stateParams);
                        if ($stateParams.param === "password")
                            return true;
                        return false;
                    }]
                }
            });
    }]);

    app.component("invalid",
        {
            templateUrl: "/App/Users/Invalid/template.html",
            controller: invalidController,
            bindings: {
                password: "<"
            }

        });

    invalidController.$inject = [];
    function invalidController() {
        var $ctrl = this;
        ng.extend($ctrl,
            {

            });
    };

})(window.app, window.angular);